import { Button } from 'components/ui/button';
import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import UsersFunctional from './index.function';
import { UserModal, UserTable } from './components';
import { fontSizes } from 'appconstants';
import ConfirmModal from 'components/ConfirmModal';
import { ReactSVG } from 'react-svg';
import { add_user_icon, search_icon } from 'asset/icons';
import TablePagination from 'components/TablePagination';
import InputField from 'components/InputField';

const Users = () => {
  const {
    users,
    isModalOpen,
    sheetMode,
    selectedUser,
    handleCreate,
    handleEdit,
    setModalOpen,
    confirmModal,
    onConfirmDeactivate,
    setConfirmModal,
    onPressDeactivate,
    delete_loading,
    page,
    onPageChange,
    search,
    onSearch
  } = UsersFunctional();

  return (
    <Wrapper className='flex flex-col h-screen'>
      <div className='flex items-center justify-between mb-6'>
        <div>
          <Text text='Manage Users' className='font-bold' size={fontSizes.h26} />
          <Text text='Control and update users' className='text-muted-foreground' />
        </div>
        <Button variant='default' className='gap-2' onClick={handleCreate}>
          <ReactSVG src={add_user_icon} /> Create User
        </Button>
      </div>

      <div className='flex gap-3 mb-3 md:mb-5'>
        <InputField
          label='Search'
          value={search}
          placeholder={'Search'}
          onChange={onSearch}
          rightIcon={search_icon}
          className='md:w-1/3'
        />
      </div>

      <UserTable users={users?.items} onEdit={handleEdit} onDeactivate={onPressDeactivate} />

      <TablePagination page={page} totalPages={users?.totalPages ?? 0} onPageChange={onPageChange} />

      <UserModal open={isModalOpen} onClose={() => setModalOpen(false)} mode={sheetMode} selectedUser={selectedUser} onDone={onPageChange} />

      <ConfirmModal
        open={confirmModal}
        title={selectedUser?.status === 'Active' ? 'Deactivate User!' : 'Activate User!'}
        description={`Are you sure you want to ${selectedUser?.status === 'Active' ? 'deactivate' : 'activate'} this user?`}
        confirmText='Yes'
        cancelText='No'
        onCancel={() => setConfirmModal(false)}
        onConfirm={() => onConfirmDeactivate()}
        loading={delete_loading}
      />
    </Wrapper>
  );
};

export default Users;
